import { Box } from "@mui/material";
import AddressRow from "./AddressRow";
import Calculate from "./Calculate";
import ProductRow from "./ProductRow";
import ShippingInformation from "./ShippingInformation";
import { useEffect, useRef } from "react";

export default function EstimateForm(props) {
  const { products, items, setItems, country, setCountry, region, setRegion, setZipCode, countries, submit, shippingData } = props;
  const bottomRef = useRef<any>(null);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [country, region, products, shippingData])

  return (
    <Box
      sx={{
        maxWidth: '100%',
        position: 'relative',
        marginX: 'auto',
      }}
    >
      <ProductRow products={products} items={items} setItems={setItems} />
      <AddressRow
        country={country}
        setCountry={setCountry}
        region={region}
        setRegion={setRegion}
        setZipCode={setZipCode}
        countries={countries}
      />
      <Calculate submit={submit} />
      <ShippingInformation shippingData={shippingData} />
      <Box ref={bottomRef}></Box>
    </Box>
  );
}